module.exports = __webpack_public_path__ + "static/card2-5b52194d09e3b7b0f0e94ae7750a6587.png";